import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

export const DASHBOARD_CONFIDENTIAL_LOGO_TEST_ID =
  'dashboard-confidential-logo';

const ConfidentialLogo = () => {
  const { t } = useTranslation('dashboard');

  return (
    <Stack
      direction="column"
      data-test-id={DASHBOARD_CONFIDENTIAL_LOGO_TEST_ID}
    >
      <Stack direction="column" sx={styles.confidentialLogo}>
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {t('Confidential.StrictlyConfidential')}
        </Typography>
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {t('Confidential.PreliminaryResults')}
        </Typography>
      </Stack>
      <Box sx={styles.subline}>{t('Confidential.NotForDistribution')}</Box>
    </Stack>
  );
};

export default ConfidentialLogo;
